import createDataContext from "./createDataContext";
import { isPast } from "date-fns";

var axios = require("axios");
var _ = require("lodash");
var qs = require("qs");

const reducer = (state, action) => {
  switch (action.type) {
    case "update_invoices":
      if (state.invoices !== action.payload.invoices) {
        console.log("PDF link", action.payload.pdfLink);
        return {
          ...state,
          invoices: action.payload.invoices,
          totalDue: action.payload.totalDue,
          overDue: action.payload.overDue,
          amount: action.payload.amount,
          loadingInvoices: false,
          paymentTotal: 0.0,
          selectedInvoices: [],
          pdfLink: action.payload.pdfLink,
          amountDropdown: action.payload.amountDropdown,
        };
      } else {
        return;
      }
    case "set_selected_invoices":
      return {
        ...state,
        selectedInvoices: action.payload,
      };
    case "set_payment_total":
      return {
        ...state,
        paymentTotal: action.payload,
      };
    case "set_autopay_modal_open":
      return {
        ...state,
        autoPayModalOpen: action.payload,
      };
    case "set_einvoicing_modal_open":
      return {
        ...state,
        eInvoicingModalOpen: action.payload,
      };
    case "update_paidYrToDate":
      return {
        ...state,
        paidYrToDate: action.payload,
      };
    case "update_autoPay":
      console.log(action)
      return {
        ...state,
        autoPay: {
          ...action.payload,
          autoPayEnabled: action.payload.autoPayEnabled === 0 ? false : true,
        },
        autoPayModalOpen: false,
      };
    case "enable_autopay":
      return {
        ...state,
        autoPay: {
          ...state.autoPay,
          autoPayEnabled: action.payload,
        },
        autoPayModalOpen: false,
      };
    default:
      return state;
  }
};

const getInvoices = (dispatch, history) => async () => {
  function createData(date, description, paid, due, status, id, pdfLink) {
    return { date, description, paid, due, status, id, pdfLink };
  }

  try {
    const response = await axios({
      method: "post",
      data: qs.stringify({
        method: "getInvoices",
      }),
      withCredentials: true,
    });

    // console.log("INVOICES", response.data);
    if (response.data.status === 0) {
      console.log("Not authenticated");
      sessionStorage.remove("authenticated");
    }
    let invoices = response.data.invoices;

    let tempRows = [];
    let totalDue = 0.0;
    let overDue = 0.0;
    let amount;
    let id;
    let pdfLink;
    let amountDropdown = response.data.amountDropdown
      ? response.data.amountDropdown
      : [];

    Object.keys(invoices).map((invoice) => {
      const tempInvoice = invoices[invoice];

      // console.log('tempinvoice', tempInvoice)

      if (typeof tempInvoice.overDue != "undefined") {
        overDue += tempInvoice.overDue;
      } else if (
        isPast(new Date(tempInvoice.dueDate)) &&
        tempInvoice.paid == false
      ) {
        overDue += tempInvoice.due;
      } else if (
        isPast(new Date(tempInvoice.dueDate)) &&
        tempInvoice.paid < tempInvoice.due
      ) {
        overDue += tempInvoice.due;
      }

      amount = tempInvoice.amount;
      id = tempInvoice.invoiceID;
      pdfLink = tempInvoice.pdfLink;

      const data = createData(
        tempInvoice.dueDate,
        tempInvoice.description,
        tempInvoice.paid.toFixed(2),
        tempInvoice.due.toFixed(2),
        _.capitalize(tempInvoice.invoiceStatus),
        tempInvoice.invoiceID,
        tempInvoice.pdfLink
      );

      tempRows.push(data);
      return (totalDue += tempInvoice.due);
    });

    dispatch({
      type: "update_invoices",
      payload: {
        invoices: tempRows,
        totalDue,
        overDue,
        amount,
        id,
        pdfLink,
        amountDropdown,
      },
    });
  } catch {
    console.log("ERrrrrror getting invoices");
  }
};

const paidYrToDate = (dispatch) => async () => {
  try {
    axios({
      method: "post",
      data: qs.stringify({
        method: "paidYrToDate",
      }),
      withCredentials: true,
    }).then((response) => {
      //console.log("PAID YR TODATE", response.data);

      dispatch({
        type: "update_paidYrToDate",
        payload: parseFloat(response.data.ytd.amount),
      });
    });
  } catch {
    console.log("Error getting paid year to date");
  }
};

const getAutoPay = (dispatch) => async () => {
  try {
    axios({
      method: "post",
      data: qs.stringify({
        method: "getAutoPay",
      }),
      withCredentials: true,
    }).then((response) => {
      //console.log("Auto Pay", response.data);

      dispatch({
        type: "update_autoPay",
        payload: response.data,
      });
    });
  } catch {
    console.log("ERrrrrror getting auto pay");
  }
};

const updateAutoPay = (dispatch) => async (
  { paymentMethod, 
    state, 
    autopay_reminder_days = '', 
    autopay_pay_advance_days = '', 
    autopay_pay_day_of_month = '', 
    autopay_max_amount = '', 
    autopay_amount_override = '',
    autopay_start_date = ''
  }) => {
  //console.log(paymentMethod);
  dispatch({
    type: "enable_autopay",
    payload: state === "off" ? 0 : 1,
  });



  try {
    axios({
      method: "post",
      data: qs.stringify({
        method: "updateAutoPay",
        paymentMethod,
        state,
        autopay_reminder_days,
        autopay_pay_advance_days,
        autopay_pay_day_of_month,
        autopay_max_amount,
        autopay_amount_override,
        autopay_start_date
      }),
      withCredentials: true,
    }).then((response) => {
      //console.log("UPDATE Auto Pay", response.data);

      if (response.data.status === 1) {
        axios({
          method: "post",
          data: qs.stringify({
            method: "getAutoPay",
          }),
          withCredentials: true,
        }).then((response) => {
          //console.log("Auto Pay", response.data);

          dispatch({
            type: "update_autoPay",
            payload: response.data,
          });
        });
      } else {
        dispatch({
          type: "enable_autopay",
          payload: state === "off" ? 1 : 0,
        });
      }
    });
  } catch {
    console.log("ERrrrrror updating auto pay");
  }
};

const setAutoPayModalOpen = (dispatch) => async (bool) => {
  dispatch({ type: "set_autopay_modal_open", payload: bool });
};

const setEinvoicingModalOpen = (dispatch) => async (bool) => {
  dispatch({ type: "set_einvoicing_modal_open", payload: bool });
};

const setSelectedInvoices = (dispatch) => async (newSelecteds) => {
  //console.log("SET SELECTED", newSelecteds);
  dispatch({ type: "set_selected_invoices", payload: newSelecteds });
};

const setPaymentTotal = (dispatch) => async (paymentTotal) => {
  //console.log("SET SELECTED", paymentTotal);
  dispatch({ type: "set_payment_total", payload: paymentTotal });
};



export const { Provider, Context } = createDataContext(
  reducer,
  {
    getInvoices,
    paidYrToDate,
    getAutoPay,
    updateAutoPay,
    setAutoPayModalOpen,
    setEinvoicingModalOpen,
    setSelectedInvoices,
    setPaymentTotal,
  },
  {
    invoices: [],
    totalDue: 0,
    paidYrToDate: 0.0,
    overDue: 0.0,
    autoPay: {
      autoPayEnabled: false,
      nextDueDate: null,
      paymentLastFour: null,
      paymentMethod: "",
      autoPaySettings : {
        autopay_reminder_days : "15",
        autopay_pay_advance_days : "",
        autopay_pay_day_of_month :"",
        autopay_max_amount : "",
        autopay_amount_override :"",
        autopay_start_date : "", 
      },
    },
    loadingInvoices: true,
    wallet: {},
    autoPayModalOpen: false,
    eInvoicingModalOpen: false,
    selectedInvoices: [],
    paymentTotal: 0.0,
    amountDropdown: [],
  }
);
